// extracted by mini-css-extract-plugin
export default {"container":"WeekDaysSelect_container__fXiyp","day":"WeekDaysSelect_day__+GKIL","activeDay":"WeekDaysSelect_activeDay__s+FWv"};